import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CustomerContactReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('CustomerContactReference', httpService);
  }

  getForCustomer(customerId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/Customer/${customerId}`);
  }
}
